import { render, staticRenderFns } from "./ColumnsPopup.vue?vue&type=template&id=7e54f6f8&scoped=true"
import script from "./ColumnsPopup.vue?vue&type=script&lang=ts"
export * from "./ColumnsPopup.vue?vue&type=script&lang=ts"
import style0 from "./ColumnsPopup.vue?vue&type=style&index=0&id=7e54f6f8&prod&lang=scss&scoped=true"
import style1 from "./ColumnsPopup.vue?vue&type=style&index=1&id=7e54f6f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54f6f8",
  null
  
)

export default component.exports